import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { loadActiveUsersNowAsync, selectActiveUsersNow, loadActiveUsersHourlyAsync, selectActiveUsersHourly } from '../dashboardSlice';
import { StatCard } from './StatCard';

const MINUTES_THRESHOLD = 15;
const POLL_INTERVAL_MS = 60 * 1000;
const HISTORY_HOURS = 24;
// A curva de fundo não precisa da mesma frequência do número ao vivo — os
// baldes são de 1h, então recarregar a cada 5 min já mantém sincronizado
// sem sobrecarregar a query de reconstrução horária.
const HISTORY_POLL_INTERVAL_MS = 5 * 60 * 1000;

// "Ativos agora" — aproximação, não presença em tempo real (ver comentário
// em getActiveUsersNow no backend): o app sincroniza heartbeat em lote,
// offline-first, não com um ping ao vivo. Por isso o rótulo deixa claro que
// é "nos últimos 15 min" em vez de insinuar uma contagem instantânea. É o
// único card que faz polling de verdade pro número em destaque — a curva
// de fundo, porém, vem de histórico persistido (getActiveUsersHourly,
// reconstruído do AppSession), não de acúmulo em memória: antes ficava só
// no estado do componente e resetava a cada reload de página.
export const ActiveUsersCard = () => {
    const dispatch = useDispatch();
    const routerHistory = useHistory();
    const { count, status } = useSelector(selectActiveUsersNow);
    const { data: hourlyData } = useSelector(selectActiveUsersHourly);

    useEffect(() => {
        dispatch(loadActiveUsersNowAsync(MINUTES_THRESHOLD));
        const interval = setInterval(() => {
            dispatch(loadActiveUsersNowAsync(MINUTES_THRESHOLD));
        }, POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [dispatch]);

    useEffect(() => {
        dispatch(loadActiveUsersHourlyAsync(HISTORY_HOURS));
        const interval = setInterval(() => {
            dispatch(loadActiveUsersHourlyAsync(HISTORY_HOURS));
        }, HISTORY_POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [dispatch]);

    const history = useMemo(
        () => (Array.isArray(hourlyData) ? hourlyData.map(d => d.activeUserCount) : []),
        [hourlyData]
    );

    return (
        <StatCard
            label="Online agora"
            secondary={`Últimos ${MINUTES_THRESHOLD} min`}
            icon="pi-users"
            color="var(--blue-500)"
            value={count}
            loading={status === 'idle'}
            history={history}
            onClick={() => routerHistory.push('/users', { preset: 'onlineNow', presetLabel: 'Online agora' })}
        />
    );
};
